import React from 'react';
import ConfirmationDialog from 'ui/dialog/ConfirmationDialog';

const REMOVE_TITLE = 'Delete Integration';
const REMOVE_TEXT = label => (
    <span>
        Are you sure you want to delete the {label} integration? <br />
        No users or data will be deleted.
    </span>
);

export const RemoveConfirm = ({ integrationLabel, onConfirm, onCancel }) => (
    <ConfirmationDialog
        open={true}
        title={REMOVE_TITLE}
        subtitle2={REMOVE_TEXT(integrationLabel)}
        onOk={onConfirm}
        onCancel={onCancel}
        showCancelButton={true}
    />
);
